// @ts-nocheck
import React, { Component } from 'react';
import _ from 'lodash';
import { inject, observer } from "../../../stores/mobx-compat";
import ReactApexChart from 'react-apexcharts';

import PageHeader from '../../ui/PageHeader';
import Card, { CardHead } from '../../ui/Card';
import KpiTile from '../../ui/KpiTile';
import { FullSpinner } from '../../ui/Spinner';
import { UsersIcon, BarChartIcon, SendIcon } from '../../ui/icons';
import { apexBase } from '../../ui/chartTheme';

const GetAMP = () => (
  <Card padded className="text-center">
    <img
      src="https://firebasestorage.googleapis.com/v0/b/mov-configs.appspot.com/o/integrationLogos%2Famp_logo_v1.png?alt=media&token=59b4f6c4-9da6-4af1-847a-322cb6de6eee"
      alt="AMP"
      style={{ display: 'block', maxWidth: 220, width: '100%', margin: '0 auto 32px' }}
    />
    <img
      src="https://firebasestorage.googleapis.com/v0/b/mov-configs.appspot.com/o/creative_assets%2FMOVology%2Famp_steps.jpg?alt=media&token=8f257af0-73d1-4d17-a5b4-10644e750660"
      alt="AMP steps"
      style={{ display: 'block', width: '80%', height: 'auto', margin: '0 auto', borderRadius: 12, border: '1px solid var(--mov-line)' }}
    />
    <h3 className="mov-display mt-8" style={{ fontSize: 22 }}>
      Interested? <em>Contact sales</em>.
    </h3>
    <a
      href="mailto:sales@automatedremarketing.com"
      className="text-mov-accent-ink underline"
    >
      sales@automatedremarketing.com
    </a>
  </Card>
);

class AMPPage extends Component {
  componentDidMount() {
    const { user = {} } = this.props.store.auth;
    if (user.features && user.features.amp && _.isEmpty(this.props.store.amp.ampData)) {
      this.props.store.amp.getAmpData();
    }
  }

  render() {
    const { user, loading } = this.props.store.auth;
    if (loading) return <FullSpinner />;

    const { ampData } = this.props.store.amp;
    if (!user.features?.AMP || _.isEmpty(ampData)) {
      return (
        <>
          <PageHeader
            eyebrow="AMP"
            title={<>Audience <em>multiplier</em>.</>}
            sub="Visitor amplification across email, display, and direct mail."
          />
          <GetAMP />
        </>
      );
    }

    const overview = [
      { label: 'Total visitors', value: ampData.overview.totalVisits.toLocaleString(), icon: UsersIcon },
      { label: 'Unique visitors', value: ampData.overview.uniqueVisits.toLocaleString(), icon: UsersIcon },
    ];

    const timeSeries = ampData['time-series'].stats;
    const dates = timeSeries.map((u) => u.type.slice(0, 10));
    const totalVisits = timeSeries.map((u) => u.total);
    const uniqueVisits = timeSeries.map((u) => u.unique);

    const barOptions = apexBase({
      chart: { type: 'bar', stacked: true },
      plotOptions: {
        bar: { columnWidth: '55%', borderRadius: 4, borderRadiusApplication: 'end', borderRadiusWhenStacked: 'last' },
      },
      xaxis: { categories: dates },
      colors: ['#7ac142', '#43bccd'],
    });
    const barSeries = [
      { name: 'Total visitors', data: totalVisits },
      { name: 'Unique visitors', data: uniqueVisits },
    ];

    const mediaReach = [
      { label: 'Display', value: ampData['media-channel-reach'][2].value, icon: BarChartIcon },
      { label: 'Direct mail', value: ampData['media-channel-reach'][3].value, icon: SendIcon },
    ];

    return (
      <>
        <PageHeader
          eyebrow="AMP"
          title={<>Audience <em>multiplier</em>.</>}
          sub="Visitor amplification across email, display, and direct mail."
        />

        <div
          className="grid gap-4 mb-5"
          style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
        >
          {overview.map((t) => (
            <KpiTile key={t.label} label={t.label} value={t.value} icon={t.icon} />
          ))}
        </div>

        <Card padded className="mb-5">
          <CardHead title="Visitors over time" />
          <ReactApexChart type="bar" height={280} options={barOptions} series={barSeries} />
        </Card>

        <div
          className="grid gap-4"
          style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}
        >
          {mediaReach.map((t) => (
            <KpiTile key={t.label} label={t.label} value={t.value.toLocaleString()} icon={t.icon} />
          ))}
        </div>
      </>
    );
  }
}

export default inject('store')(observer(AMPPage));
